import { render } from "./SearchResultPage.vue?vue&type=template&id=e9200c04&scoped=true&ts=true"
import script from "./SearchResultPage.vue?vue&type=script&lang=ts"
export * from "./SearchResultPage.vue?vue&type=script&lang=ts"

import "./SearchResultPage.vue?vue&type=style&index=0&id=e9200c04&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9200c04"]])

export default __exports__